var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"my-3"},[_c('ListHeader',{attrs:{"text":"分類","value":"categories"}}),_c('ListTable',{attrs:{"value":"categories","items":_vm.categories,"fields":_vm.fields},on:{"remove":_vm.removeCategory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }